<template>
  <div id="notification">
    <Hero
      v-bind:title="$t('views.notification.title')"
    />

    <div class="content-wrapper">
      <NotificationHome/>
    </div>

  </div>
</template>

<script>
import NotificationHome from '@/components/notification/NotificationHome.vue'
import Hero from '@/components/plans/Hero.vue'

export default {
  name: 'Notification',
  components: {
    Hero,
    NotificationHome
  }
}
</script>

<style lang="scss">
#notification {
  .hero {
    background-image: url('../assets/backgrounds/smoke-profile.png');
    background-size: contain;
    min-height: 180px;
  }
}
</style>
